import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  // scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
        path: '/404',
        name: '404',
        component: require('@/pages/common/404')
    },
    {
        path: '*',
        redirect: '404'
    },
    {
      path: '/opslag/:licenseplate',
      name: 'Lookup',
      component: require('@/pages/common/index')
    },
    {
      path: '/',
      name: 'Landing',
      component: require('@/pages/common/landing')
    },
    {
      path: '/sammenlign',
      name: 'Compare',
      component: require('@/pages/common/compare')
    },
    {
      path: '/soeg/:licenseplate',
      name: 'Search',
      component: require('@/pages/common/search/index'),
      children: [
        {
          path: 'overblik',
          name: 'SearchOverview',
          component: require('@/pages/common/search/pages/overview')
        },
        {
          path: 'bilbogen',
          name: 'SearchRegistry',
          component: require('@/pages/common/search/pages/registry')
        },
        {
          path: 'synsrapporter',
          name: 'SearchReports',
          component: require('@/pages/common/search/pages/reports')
        },
        {
          path: 'afgifter',
          name: 'SearchCharges',
          component: require('@/pages/common/search/pages/charges')
        },
        {
          path: 'tidslinje',
          name: 'SearchTimeline',
          component: require('@/pages/common/search/pages/timeline')
        },
        {
          path: 'teknisk-info',
          name: 'SearchTechnicalInfo',
          component: require('@/pages/common/search/pages/technical-info')
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js